export enum LotVariationPermissionEnum {
    None = 0x00,
    LotChangeCanViewVariation = 0x01 << 0,
    LotChangeCanCreateVariation = 0x01 << 1,
    LotChangeCanEditVariation = 0x01 << 2,
    LotChangeCanGenerateVariationReport = 0x01 << 3,
    LotChangeCanFinaliseVariation = 0x01 << 4,
    LotChangeCanDeleteVariation = 0x01 << 5
}
